import * as React from "react";
import { SVGProps } from "react";
const SvgLogoAzure = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} {...props}>
    <defs>
      <radialGradient
        id="logo-azure_svg__a"
        gradientUnits="userSpaceOnUse"
        cx={-67.981}
        cy={793.199}
        fx={-67.981}
        fy={793.199}
        r={0.45}
        gradientTransform="rotate(45 -29827.466 -10195.832) scale(22.30311 -30.35467)"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#83b9f9",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#0078d4",
            stopOpacity: 1,
          }}
        />
      </radialGradient>
    </defs>
    <path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "url(#logo-azure_svg__a)",
      }}
      d="M0 2.398v11.204A2.399 2.399 0 0 0 2.398 16h11.204A2.399 2.399 0 0 0 16 13.602V2.398A2.399 2.399 0 0 0 13.602 0H2.398A2.399 2.399 0 0 0 0 2.398ZM9.602 0v3.2A6.4 6.4 0 0 0 16 9.601h-3.2A6.402 6.402 0 0 0 6.399 16v-3.2A6.4 6.4 0 0 0 0 6.399h3.2A6.4 6.4 0 0 0 9.601 0Zm0 0"
    />
  </svg>
);
export default SvgLogoAzure;
